<p-button
  (onClick)="handleRemoveClick()"
  [text]="true"
  pTooltip="Usuń z koszyka"
  size="small"
  styleClass="bg-primary text-white"
  tooltipPosition="bottom"
  type="button">
  <app-icon [icon]="Icon.X_LG" />
</p-button>
